<app-validation-mail *ngIf="mode === 'verifyEmail'" fxFlexFill></app-validation-mail>
<app-reset-password *ngIf="mode === 'resetPassword'" fxFlexFill></app-reset-password>